import app from 'flarum/forum/app';
import Component from "flarum/Component";
import Link from "flarum/components/Link";
import Button from "flarum/components/Button";
import Tooltip from "flarum/common/components/Tooltip";

// import SignUpModal from 'flarum/components/SignUpModal';
// import LogInModal from 'flarum/components/LogInModal';
// import logCTA from '../utils/logCTA';
import { slug } from '../../common';
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.welcome`;

class Item extends Component {
  view({ attrs }) {
    return (
      <Tooltip text={attrs.text}>
        <Link href={attrs.href} className={attrs.className}>
          <i class={attrs.icon} />
        </Link>
      </Tooltip>
    );
  }
}
/*
<p>
    Join the VietNam-speaking development community.
        An enthusiastic young community full of ideas, creativity and...
        effort in <b>web development</b>,{" "}
        <b>game development</b> and <b>internet of things</b>.
    </p>
    <p>
    Get inspired by other developers' projects{" "}
        <Link href={app.route('tags')}>in the showcase</Link> or share
        project you are working on. Support each other by{" "}
        <Link href={app.route('tags')}>ask questions</Link> and too
        answer and broaden your knowledge with the {" "}
        <Link href={app.route('tags')}>follow tutorials</Link>!
    </p>

    <p>
                Join the VietNam-speaking development community.
                   An enthusiastic young community full of ideas, creativity and...
                   effort in <b>internet of things</b> unremitting efforts.{" "}
                </p>
*/          
export default class HomeWelcomeContainer extends Component {
  view() {
    return (
      <div
        className={`HomeWelcomeContainer ${app.session.user && `HomeWelcomeContainer-User`}`}>
        <div className={"HomeWelcomeContainer-TopContainer"}>
          <div className={"HomeWelcomeContainer-TopContainer-background"} />
          <div className={`HomeWelcomeContainer-content ${!app.session.user && `HomeWelcomeContainer-content-guest`}`}>
            <h2>
              {app.session.user
                ? `${t(`${prfx}.title_back`)}, ${app.session.user.displayName()}`
                : `👋 ${t(`${prfx}.title_to`)}`}
            </h2>

            {!app.session.user && (
              <>
                <p>
                Tham gia cộng đồng phát triển nói tiếng Việt..
                   Một cộng đồng trẻ đầy nhiệt huyết, đầy ý tưởng, sáng tạo và...
                   nỗ lực trong internet vạn vật không ngừng nghỉ..{" "}
                </p>
                <p>
                Bạn có thể chia sẻ dự án bạn đang thực hiện.{" "}
                    Hỗ trợ lẫn nhau bằng cách <Link href={app.route('tags')}>hỏi và trả lời</Link> các 
                    câu hỏi cũng như mở rộng kiến ​​thức của bạn bằng cách <Link href={app.route('tags')}>làm theo các hướng dẫn</Link> !{" "}
                </p>
              </>
            )}
          </div>

          {!app.session.user && (
            <div className={"HomeWelcomeContainer-items"}>
              <Item
                text={"CSS3"}
                href={app.route('tags')}
                className={"item-css"}
                icon={"fab fa-css3"}
              />
              <Item
                text={"Game development"}
                href={app.route('tags')}
                className={"item-games"}
                icon={"fas fa-gamepad"}
              />
              <Item
                text={"JavaScript"}
                href={app.route('tags')}
                className={"item-javascript"}
                icon={"fab fa-js"}
              />
              <Item
                text={"Programmeren"}
                href={app.route('tags')}
                className={"item-code"}
                icon={"fas fa-code"}
              />
              <Item
                text={"Node.js"}
                href={app.route('tags')}
                className={"item-nodejs"}
                icon={"fab fa-node"}
              />
              <Item
                text={"HTML5"}
                href={app.route('tags')}
                className={"item-html5"}
                icon={"fab fa-html5"}
              />
              <Item
                text={"WordPress"}
                href={app.route('tags')}
                className={"item-wordpress"}
                icon={"fab fa-wordpress-simple"}
              />
              <Item
                text={"React.js"}
                href={app.route('tags')}
                className={"item-react"}
                icon={"fab fa-react"}
              />
              <Item
                text={"Unity 3D"}
                href={app.route('tags')}
                className={"item-unity"}
                icon={"fab fa-unity"}
              />
            </div>
          )}
        </div>

        <div className={"HomeWelcomeContainer-FooterButtons"}>
          <ul className={"HomeWelcomeContainer-CTAContainer"}>
            <li>
              <Link href={app.route('blog')} className={"HomeWelcomeContainer-FooterButton"} >
                <div className={"service-icon"}>📚</div>
                <div className={"service-info"}>
                    <b>{t(`${prfx}.blog.title`)}</b>
                    <span>{t(`${prfx}.blog.desc`)}</span>
                    <span className={"service-cta"}>
                        <i className={"fal fa-chevron-double-right"} /> {t(`${prfx}.blog.post`)}
                    </span>
                </div>
              </Link>
            </li>
            <li>
              <Link href={app.route('tag', { tags: 'hoi-va-dap' })} className={"HomeWelcomeContainer-FooterButton"}>
                <div className={"service-icon"}>🤝</div>
                <div className={"service-info"}>
                    <b>{t(`${prfx}.question.title`)}</b>
                    <span>{t(`${prfx}.question.desc`)}</span>
                    <span className={"service-cta"}>
                        <i className={"fal fa-chevron-double-right"} /> {t(`${prfx}.question.post`)}
                    </span>
                </div>
              </Link>
            </li>
            <li>
              <Link href={app.route('tag', { tags: 'goc-chia-se' })} className={"HomeWelcomeContainer-FooterButton"}>
                <div className={"service-icon"}>✨</div>
                <div className={"service-info"}>
                    <b>{t(`${prfx}.project.title`)}</b>
                    <span>{t(`${prfx}.project.desc`)}</span>
                    <span className={"service-cta"}>
                        <i className={"fal fa-chevron-double-right"} /> {t(`${prfx}.project.post`)}
                    </span>
                </div>
              </Link>
            </li>
            <li>
              <Link href={"/categories"} className={"HomeWelcomeContainer-FooterButton"}>
                <div className={"service-icon"}>🏷️</div>
                <div className={"service-info"}>
                    <b>{t(`${prfx}.category.title`)}</b>
                    <span>{t(`${prfx}.category.desc`)}</span>
                    <span className={"service-cta"}>
                        <i className={"fal fa-chevron-double-right"} /> {t(`${prfx}.category.post`)}
                    </span>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
     /*TEST USER
      <div
      className={`HomeWelcomeContainer ${!app.session.user && `HomeWelcomeContainer-User`}`}>
      <div className={"HomeWelcomeContainer-TopContainer"}>
        <div className={"HomeWelcomeContainer-TopContainer-background"} />
        <div className={`HomeWelcomeContainer-content ${app.session.user && `HomeWelcomeContainer-content-guest`}`}>
          <h2>
            {app.session.user
              ? `Welcome back, ${app.session.user.displayName()}`
              : `👋 Welcome to KVS`}
          </h2>

          {app.session.user && (
            <>
              <p>
              Join the VietNam-speaking development community.
                 An enthusiastic young community full of ideas, creativity and...
                 effort in <b>web development</b>,{" "}
                 <b>game development</b> and <b>internet of things</b>.
              </p>

              <p>
              Get inspired by other developers' projects{" "}
                 <Link href="/t/showcase">in the showcase</Link> or share
                 project you are working on. Support each other by{" "}
                 <Link href="/t/help-need">ask questions</Link> and too
                 answer and broaden your knowledge with the {" "}
                 <Link href="/t/tutorials">follow tutorials</Link>!
              </p>
            </>
          )}
        </div>

        {app.session.user && (
          <div className={"HomeWelcomeContainer-items"}>
            <Item
              text={"CSS3"}
              href={"/t/css3"}
              className={"item-css"}
              icon={"fab fa-css3"}
            />
            <Item
              text={"Game development"}
              href={"/t/games"}
              className={"item-games"}
              icon={"fas fa-gamepad"}
            />
            <Item
              text={"JavaScript"}
              href={"/t/javascript"}
              className={"item-javascript"}
              icon={"fab fa-js"}
            />
            <Item
              text={"Programmeren"}
              href={"/t/programmeren"}
              className={"item-code"}
              icon={"fas fa-code"}
            />
            <Item
              text={"Node.js"}
              href={"/t/nodejs"}
              className={"item-nodejs"}
              icon={"fab fa-node"}
            />
            <Item
              text={"HTML5"}
              href={"/t/html-5"}
              className={"item-html5"}
              icon={"fab fa-html5"}
            />
            <Item
              text={"WordPress"}
              href={"/t/wordpress"}
              className={"item-wordpress"}
              icon={"fab fa-wordpress-simple"}
            />
            <Item
              text={"React.js"}
              href={"/t/react"}
              className={"item-react"}
              icon={"fab fa-react"}
            />
            <Item
              text={"Unity 3D"}
              href={"/t/unity"}
              className={"item-unity"}
              icon={"fab fa-unity"}
            />
          </div>
        )}
      </div>

      <div className={"HomeWelcomeContainer-FooterButtons"}>
        <ul className={"HomeWelcomeContainer-CTAContainer"}>
          <li>
            <Link
              href={"/t/tutorials"}
              className={"HomeWelcomeContainer-FooterButton"}
            >
              <div className={"service-icon"}>📚</div>
              <div className={"service-info"}>
              <b>Tutorials</b>
                 <span>Learn to program your way.</span>
                 <span className={"service-cta"}>
                   <i className={"fal fa-chevron-double-right"} /> View all tutorials
                 </span>
              </div>
            </Link>
          </li>
          <li>
            <Link
              href={"/t/hulp-nodig"}
              className={"HomeWelcomeContainer-FooterButton"}
            >
              <div className={"service-icon"}>🤝</div>
              <div className={"service-info"}>
                <b>Question &amp; answer</b>
                <span>Do you have a problem with your code?</span>
                <span className={"service-cta"}>
                  <i className={"fal fa-chevron-double-right"} /> Post your question
                </span>
              </div>
            </Link>
          </li>
          <li>
            <Link
              href={"/t/showcase"}
              className={"HomeWelcomeContainer-FooterButton"}
            >
              <div className={"service-icon"}>✨</div>
              <div className={"service-info"}>
              <b>Projects</b>
                 <span>Inspire &amp; iterate.</span>

                 <span className={"service-cta"}>
                   <i className={"fal fa-chevron-double-right"} /> View all projects
                 </span>
              </div>
            </Link>
          </li>
          <li>
            <Link
              href={"/t/showcase"}
              className={"HomeWelcomeContainer-FooterButton"}
            >
              <div className={"service-icon"}>🏷️</div>
              <div className={"service-info"}>
              <b>All categories</b>
                 <span>Browse all categories.</span>

                 <span className={"service-cta"}>
                   <i className={"fal fa-chevron-double-right"} /> All
                   categories
                 </span>
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </div>*/
 
    );
  }
}